export default __webpack_public_path__ + "static/media/band.61f210c4.png";